import React from 'react';
import Section from './Section';
import './Experience.css';

const Experience = () => {
  const experiences = [
    {
      company: "Lumentum, OCS Design Verification",
      role: "Automation & Test Co-op",
      period: "2026",
      highlights: [
        "Automated OpenConfig enrollment and path authorization tests with Pytest and gRPC.",
        "Built a Python reporting tool using the Confluence API, saving 10+ hours of manual work per week.",
        "Added GitHub Actions release testing and Docker-based test deployment.",
        "Modernized .NET test applications and packaged installers with WiX."
      ],
      technologies: ["Python", "PKI", "X.509 Certificates", "Pytest", "OpenConfig", "gRPC", "Docker", "Confluence API", "GitHub Actions", ".NET", "WiX", "SVN", "Git"],
      image: "/images/lumentum.jpg"
    },
    {
      company: "Ciena Corporation, Photonics Software Team",
      role: "Embedded Software Co-op",
      period: "2025",
      highlights: [
        "Built a Python tool to identify system faults from alarms and logs.",
        "Created Jenkins pipelines for optical card testing and load-submission checks.",
        "Documented automation tools and frameworks for onboarding."
      ],
      technologies: ["Python", "Jenkins", "Confluence"],
      image: "/images/ciena.jpg"
    },
    {
      company: "Ciena Corporation, Photonics Software Team",
      role: "Embedded Software Summer Intern",
      period: "2024",
      highlights: [
        "Automated optical-device upgrade procedures in Python for regression testing.",
        "Reduced manual test time by 50% with ROADM bootstrap sanity automation.",
        "Reviewed code changes for software load quality."
      ],
      technologies: ["Python", "ROADM Systems"],
      image: "/images/ciena.jpg"
    },
    {
      company: "Team Panorama, Panorama Mountain Resort",
      role: "Ski Racing Coach",
      period: "2024-2025",
      highlights: [
        "Coached youth athletes through structured technical training."
      ],
      technologies: ["Leadership", "Strategic Communication", "Team Collaboration"],
      image: "/images/panorama.jpg"
    }
  ];

  return (
    <Section
      id="experience"
      title="Experience"
      subtitle="Professional work and measurable outcomes."
      className="experience-section"
    >
      <div className="experience-timeline">
        {experiences.map((exp, index) => (
          <div
            key={index}
            className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
            style={{ animationDelay: `${index * 0.2}s` }}
          >
            <div className="timeline-image-wrapper">
              <img src={exp.image} alt={exp.company} className="timeline-image" />
            </div>
            <div className="timeline-content">
              <div className="timeline-header">
                <h3 className="company-name">{exp.company}</h3>
                <span className="role">{exp.role}</span>
                <span className="period">{exp.period}</span>
              </div>
              <ul className="experience-highlights">
                {exp.highlights.map((highlight) => (
                  <li key={highlight}>{highlight}</li>
                ))}
              </ul>
              <div className="technologies">
                {exp.technologies.map((tech, techIndex) => (
                  <span key={techIndex} className="tech-badge">{tech}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default Experience;
